// Single chokepoint for replacing the current URL. Lives in its own module
// so tests can mock it via vi.spyOn; jsdom marks Location.replace as
// non-configurable, which blocks spying on window.location.replace directly.
export const navigateReplace = (url) => {
    window.location.replace(url);
};
